// @flow
import * as React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import attributeMessages from 'esm-web-pro/messages/attributeMessages';

type Props = {
    document: Object,
    intl: IntlShape,
};

const DocumentsAttributes = (props: Props) => {
    const { document, intl: { formatMessage } } = props;
    const {
        file, stages,
    } = document;


    const attributes = [
        {
            label: `${formatMessage(attributeMessages.stages)}`,
            value: stages.map((stage) => stage.name).join(', '),
        },
    ];

    return <Attributes attributes={attributes} />;
};

export default injectIntl(DocumentsAttributes);
